import styled from "styled-components/macro";

export const FaqTitle = styled.h1`
  padding-top: 2em;

  font-size: ${(props) => props.theme.font.sizeBanner};
  font-weight: ${(props) => props.theme.font.weightMedium};
  font-family: ${(props) => props.theme.font.family};
  color: ${(props) => props.theme.colors.text};

  & > span {
    color: ${(props) => props.theme.colors.primary};
  }
`;

export const FaqDiv = styled.div`
  scroll-behavior: smooth;
  background-color: white;
  display: block;
  position: relative;
  width: 100%;
  text-align: center;
  margin: 0 auto 0;
`;

export const FaqSection = styled.section`
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 16px;
  max-width: ${(props) => props.theme.sizes.maxWidthMainWindow};
  margin:  auto ;
  text-align: left;
  #sticky-container {
    position: sticky;
    height: calc(90vh - 96px);
    padding-top: 1em;
    padding-left: 1em;
    top: 0;
    @media ${(props) => props.theme.media.phone} {
      position: static;
      height: fit-content;
      width: 95%;
    }

    #sticky-faq {
      position: absolute;
      padding: 1.5625em;
      overflow-y: auto;
      background-color: ${(props) => props.theme.colors.bgSecondary};
      border-radius: 6px;
      // height: 100%;
      @media ${(props) => props.theme.media.phone} {
        height: fit-content;
        position: static;
      }

      & > ul {
        margin: 0;
      }
  }

  }

  #becomingHost,
  #registrationVerification,
  #matchmaking,
  #myHome,
  #rental,
  #tax,
  #surcharges,
  #registration,
  #matching,
  #hostStay,
  #costs,
  #about {
    scroll-margin-top: 150px;
  }

  @media ${(props) => props.theme.media.phone} {
    grid-template-columns: 1fr;
    &  nav {
      position: static;
      & > ul {
        display: flex;
        flex-wrap: wrap;
        padding: 8px 0;
        margin: 0;
        list-style-type: circle;
        & > li {
          padding: 0 4px;
          &:last-child {
            border: none;
            padding: 0 0 0 4px;
          }
          &:first-child {
            padding: 0 4px 0 0;
          }
        }
      }
    }
    & > main {
      grid-area: auto;
    }
  }
`;

export const NavFaq = styled.nav`
  padding: 0 1rem ;
  max-width: 280px;
  height: fit-content;
  @media ${(props) => props.theme.media.phone} {
    max-width: 100%;
  }
  & > ul {
    padding: 16px 0 0 16px;
    & > li {
      list-style: none;
      & > a {
        color: ${(props) => props.theme.colors.text};
        font-size: 18px;
        font-weight: ${(props) => props.theme.font.weightNormal};
        &.active,
        &:hover {
          color: ${(props) => props.theme.colors.primary};
        }
      }
    }
  }
`;

export const MainPlace = styled.main`
  padding: 1em 1rem;
  grid-area: 1 / 2 / auto / auto;
  & > h1:not(h1:first-child) {
    margin-top: 24px;
  }
  & > section {
    & > ul {
      padding: 16px 0 0 0;
      & > li {
        list-style: none;
        & > p {
          color: ${(props) => props.theme.colors.text};
          font-size: 18px;
          &:first-child {
            font-weight: ${(props) => props.theme.font.weightBold};
            margin: 0 0 8px 0;
          }
        }
      }
    }
  }
`;
